<template>
  <div>
    <div class="yk-wrap-fixed wlx-site-manager-wrapper">
      <header class="u-school-manager-head site-manager-head-con">
        <span class="fl sp-test-detail-title">{{schoolName}}</span>
         <el-form :inline="true">
            <!-- <el-form-item>
              <div>
                <el-input v-model="DisplayName" placeholder="请输入姓名" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div>
                <el-select v-model="planId" clearable placeholder="请选择培训轮次">
                  <el-option
                    v-for="item in planList"
                    :key="item.Id"
                    :label="item.planTime"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </div>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" icon="wl-icon-ai207" @click="goBack"></el-button>
            </el-form-item>
          </el-form>
      </header>
      <div class="wlx-table-content">
        <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="managerUserName" label="账号"></el-table-column>
          <el-table-column prop="managerUserDisplayName" label="姓名"></el-table-column>
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">培训</span>
              <span v-else-if="scope.row.type == 2">考核</span>
            </template>
          </el-table-column>
          <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button size="mini"
                        type="danger"
                        class="el-icon-delete"
                        @click="deleteSchoolManagerList(scope.row.id)"
              titlt="删除"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      ids: [],
      CreateDisplayName: "",
      hotelTitle:"",
      schoolName: "",
      dialogVisible:false,
      tosititle:'',
      form:{
        id:'',
        titlt:'',
        price:'',
        isBreakfast:''
      }
    };
  },
  props: {
    schoolId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getSchoolManagerList(1);
  },
  methods: {
    getSchoolManagerList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/SchoolManager/getSchoolManagerList", {
          schoolId: this.schoolId
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.schoolName = rst.schoolName;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    deleteSchoolManagerList(id) {
      this.$confirm("此操作将删除该管理员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var that = this;
          this.$http
            .post("/api/XOrg/SchoolManager/deleteSchoolManager", {
              ids: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getSchoolManagerList(1);
              }else{
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    goBack(){
      this.$router.push({
         name:'adoptSchool'
       });
    }
  }
};
</script>

<style lang="scss">
.yk-wrap-fixed {
  .sp-test-detail-title {
    padding: 0 15px;
    font-size: 16px;
    color: #2d82ff;
    // border-bottom: 2px solid #2d82ff;
    line-height: 59px;
    min-width: 30px;
    text-align: center;
  }
  .wlx-table-content {
    margin-top: 84px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .wl-pagination-text {
    text-align: center;
    margin-top: 30px;
  }
  .site-manager-head-con {
    text-align: right;
  }
  .el-form-item__content {
    .el-button {
      padding: 8px 15px;
    }
  }
  .export-button-a{
    color: #fff;
    background: #409EFF;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
